import { useEffect, useState } from "react";
import Logo from "../assets/logo-heavy.svg";
import GoogleIcon from "../assets/google-icon.svg";

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const handleLogin = () => {
    window.location.href = "https://vitru-trade-backend-production.up.railway.app/auth/google";
  }
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav className={`w-screen md:w-[80%] fixed md:top-6 md:left-1/2 md:-translate-x-1/2 flex justify-between items-center ${scrolled ? "bg-white md:bg-white/90 shadow-md md:backdrop-blur-sm" : "bg-white md:bg-transparent"} px-6 py-4 md:rounded-full z-50`}>
      <img src={Logo} alt="vitrutrade logo" className="w-10 h-10"/>
      <button onClick={handleLogin}><img src={GoogleIcon} alt="sign in with google button"/></button>
    </nav>
  )
};